import { IWorkspace } from '@elyx-code/definitions';
import { create } from 'zustand';

interface WorkspaceStore {
	activeWorkspace: IWorkspace | null;
	setActiveWorkspace: (workspace: IWorkspace) => void;
}

export const useWorkspaceStore = create<WorkspaceStore>((set) => ({
	activeWorkspace: null,
	setActiveWorkspace: (workspace) => set({ activeWorkspace: workspace }),
}));
